/**
 * Utilitaires pour le formatage et la gestion des prix
 */

/**
 * Formater un prix en USD avec 2 décimales
 */
export const formatPrice = (price) => {
  if (price == null || price === undefined || isNaN(price)) {
    return '0.00';
  }
  return Number(price).toFixed(2);
};

/**
 * Obtenir le prix du produit (gère ancien et nouveau format)
 */
export const getProductPrice = (order) => {
  if (order.totalProductPrice != null) {
    return Number(order.totalProductPrice);
  }
  if (order.productPrice != null) {
    return Number(order.productPrice);
  }
  return 0;
};

/**
 * Obtenir la commission (gère ancien et nouveau format)
 */
export const getCommission = (order) => {
  if (order.totalCommission != null) {
    return Number(order.totalCommission);
  }
  if (order.commission != null) {
    return Number(order.commission);
  }
  return 0;
};

/**
 * Obtenir les frais de livraison (gère ancien et nouveau format)
 */
export const getDeliveryFee = (order) => {
  if (order.totalDeliveryFee != null) {
    return Number(order.totalDeliveryFee);
  }
  if (order.deliveryFee != null) {
    return Number(order.deliveryFee);
  }
  return 0;
};

/**
 * Obtenir le montant total
 */
export const getTotalAmount = (order) => {
  if (order.finalAmount != null) {
    return Number(order.finalAmount);
  }
  if (order.totalAmount != null) {
    return Number(order.totalAmount);
  }
  return 0;
};

/**
 * Vérifier si une commande a plusieurs produits
 */
export const hasMultipleProducts = (order) => {
  return (
    (order.items && Array.isArray(order.items) && order.items.length > 0) ||
    order.totalProductPrice != null ||
    order.totalCommission != null ||
    order.totalDeliveryFee != null
  );
};

/**
 * Obtenir les produits d'une commande (gère ancien et nouveau format)
 */
export const getOrderProducts = (order) => {
  if (hasMultipleProducts(order) && order.items) {
    return order.items;
  }
  
  // Ancien format : créer un tableau avec un seul produit
  return [{
    imageUrl: order.imageUrl,
    productLink: order.productLink,
    size: order.size,
    color: order.color,
    quantity: order.quantity || 1,
    comment: order.comment,
    verifiedProductName: order.verifiedProductName,
    productPrice: order.productPrice,
    commission: order.commission,
    subtotal: order.productPrice && order.commission 
      ? order.productPrice + order.commission 
      : null,
  }];
};





